import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { KeycloakService } from '../services/keycloak/keycloak.service';

export const authGuard: CanActivateFn = (route, state) => {
  const keycloakService = inject(KeycloakService);

  if (keycloakService.isAuthenticated()) {
    // Clean up URL after Keycloak redirect
    const url = window.location.href;
    if (
      url.includes('#iss=') ||
      url.includes('?code=') ||
      url.includes('&state=')
    ) {
      window.history.replaceState(null, '', window.location.pathname);
    }
    return true;
  }

  // Store intended route for post-login redirect
  sessionStorage.setItem('redirectUrl', state.url);

  // Redirect to login
  return keycloakService.login().pipe(map(() => true));
};
